/* ════════════════════════════════════════════════════════════════════════════
   HTML del autodiagnóstico — Identificación y Clasificación de Proveedores
   Marcos: ENS · ENISA · NIS2 · RGPD
   Se inyecta en #psq-proveedores-wrap cuando se abre la herramienta.
   ════════════════════════════════════════════════════════════════════════════ */
window.psqProveedoresHTML = `
<div class="page active">

  <div class="psq-header">
    <h1>Identificación y clasificación de proveedores</h1>
    <p style="color:#64748b;font-size:13px;margin-top:6px">Determina el nivel de riesgo del proveedor según criterios alineados con ENS, ENISA, NIS2 y RGPD Art. 28</p>
  </div>

  <!-- ═════ VISTA 1: FORMULARIO ═════════════════════════════════════════════ -->
  <div id="pg-proveedores-form" class="psq-stage active">

    <div class="psq-card">
      <h3 class="psq-sec-title">Datos del proveedor</h3>
      <div class="psq-grid2">
        <div class="psq-field" style="grid-column:1/-1">
          <label>Nombre del proveedor *</label>
          <input type="text" id="pr-supplier" placeholder="Ej: CloudTech Solutions, S.L.">
        </div>
        <div class="psq-field" style="grid-column:1/-1">
          <label>Servicio prestado *</label>
          <input type="text" id="pr-service" placeholder="Ej: Hosting cloud, SOC, desarrollo, nómina…">
        </div>
        <div class="psq-field">
          <label>Evaluador</label>
          <input type="text" id="pr-evaluator" placeholder="Nombre y apellidos">
        </div>
        <div class="psq-field">
          <label>Fecha de evaluación</label>
          <input type="date" id="pr-date">
        </div>
      </div>
      <div class="psq-field" style="margin-bottom:0">
        <label>Correo electrónico *</label>
        <input type="text" id="pr-email" placeholder="correo@empresa.com">
      </div>
    </div>

    <div class="psq-card">
      <h3 class="psq-sec-title">Criterios de clasificación</h3>
      <p style="font-size:12px;color:#64748b;margin-top:-8px;margin-bottom:14px">Marca la opción correspondiente para cada criterio. La clasificación resultante determinará las buenas prácticas aplicables en cada fase del ciclo de vida del servicio.</p>
      <div id="pr-questions"></div>
    </div>

    <div class="psq-disclaimer">
      <div class="psq-disclaimer-inner">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#0d6efd" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="flex-shrink:0;margin-top:2px"><circle cx="12" cy="12" r="10"/><line x1="12" y1="16" x2="12" y2="12"/><line x1="12" y1="8" x2="12.01" y2="8"/></svg>
        <div><strong>Evaluación 100% en tu navegador.</strong> Los datos del proveedor no se envían a Zerolynx ni a terceros. El informe resultante es orientativo y no sustituye una evaluación formal de riesgos de terceros conforme a ISO 27036 ni una auditoría reglada del proveedor.</div>
      </div>
    </div>

    <div id="pr-missing" class="psq-missing">Completa todos los criterios, nombre del proveedor, servicio y correo electrónico para generar el informe.</div>

    <div class="psq-stage-nav">
      <button class="psq-btn psq-btn-ghost" onclick="showLanding()">← Volver</button>
      <button class="psq-btn psq-btn-primary" id="pr-start-btn" onclick="psqProveedoresStart()" disabled style="opacity:0.5;cursor:not-allowed;background:#0d6efd !important">Generar informe →</button>
    </div>

  </div>

  <!-- ═════ VISTA 2: RESULTADOS ════════════════════════════════════════════ -->
  <div id="pg-proveedores-results" class="psq-stage" style="display:none">

    <div class="psq-toolbar">
      <button class="psq-btn psq-btn-ghost" onclick="psqProveedoresBack()">← Editar evaluación</button>
      <button class="psq-btn psq-btn-primary" onclick="psqProveedoresExportPDF()" style="background:#0d6efd !important">Descargar informe PDF</button>
    </div>

    <div class="psq-card">
      <div style="display:flex;justify-content:space-between;align-items:flex-start;flex-wrap:wrap;gap:16px">
        <div style="flex:1;min-width:220px">
          <h2 style="margin:0 0 4px;font-size:18px">Informe de clasificación de proveedor</h2>
          <p id="pr-r-supplier" style="font-size:14px;color:#1e293b;font-weight:700">-</p>
          <p id="pr-r-service" style="font-size:13px;color:#475569;margin-top:2px">-</p>
          <p id="pr-r-meta" style="font-size:12px;color:#64748b;margin-top:6px">-</p>
          <div style="display:flex;flex-wrap:wrap;gap:4px;margin-top:10px">
            <span class="psq-frame-tag psq-tag-cis">ENS</span>
            <span class="psq-frame-tag psq-tag-cis">ENISA SCM</span>
            <span class="psq-frame-tag psq-tag-samm">NIS2</span>
            <span class="psq-frame-tag psq-tag-forense">RGPD Art. 28</span>
          </div>
        </div>
        <div class="psq-score-num">
          <div class="psq-num" id="pr-r-score" style="color:#0d6efd">0</div>
          <div class="psq-sub">/ 100</div>
          <div class="psq-lbl" id="pr-r-label" style="background:#0d6efd">Nivel</div>
        </div>
      </div>
      <div id="pr-r-verdict-banner" style="margin-top:16px;padding:14px;border-radius:10px;border-left-width:4px;border-left-style:solid">
        <strong id="pr-r-verdict-title" style="font-size:14px">Clasificación</strong>
        <p id="pr-r-verdict-desc" style="font-size:12px;margin:4px 0 0;line-height:1.5">-</p>
      </div>
    </div>

    <div class="psq-card">
      <h3 class="psq-sec-title">Niveles de clasificación de referencia</h3>
      <div class="psq-domain-grid" id="pr-r-levels-grid"></div>
    </div>

    <div class="psq-card">
      <h3 class="psq-sec-title">Detalle de la evaluación</h3>
      <table>
        <thead><tr><th>#</th><th>Categoría</th><th>Pregunta</th><th>Respuesta</th><th>Peso</th></tr></thead>
        <tbody id="pr-r-questions-tbody"></tbody>
      </table>
    </div>

    <div class="psq-card">
      <h3 class="psq-sec-title">Controles ENS aplicables</h3>
      <p style="font-size:12px;color:#64748b;margin-top:-8px;margin-bottom:10px">RD 311/2022 · controles específicos según el nivel de riesgo identificado</p>
      <table>
        <thead><tr><th>Marco</th><th>Descripción</th></tr></thead>
        <tbody id="pr-r-ens-tbody"></tbody>
      </table>
    </div>

    <div class="psq-card">
      <h3 class="psq-sec-title">Buenas prácticas por fase del servicio</h3>
      <p style="font-size:12px;color:#64748b;margin-top:-8px;margin-bottom:14px">Acciones recomendadas alineadas con ENS, ENISA SCM Guidelines, NIS2 y RGPD</p>
      <div id="pr-r-phases"></div>
    </div>

    <div class="psq-card">
      <h3 class="psq-sec-title">Tipología de proveedores en este nivel</h3>
      <div id="pr-r-examples"></div>
    </div>

    <p id="pr-r-footer" style="text-align:center;font-size:11px;color:#94a3b8;margin-top:12px">-</p>

  </div>

</div>
`;
